import { Component, Input, OnInit } from '@angular/core';
import { Project } from 'src/app/shared/models';

@Component({
    selector: 'app-project-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  @Input() project: Project;
  // Legacy labor / equipment code setup. Kept for the few projects that still
  // use it, but collapsed by default so it doesn't crowd the project settings.
  legacyOpen = false;

  constructor() { }

  ngOnInit(): void {
  }

}
